/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_League_DescInputs */



/**
* | output |
* | --- |
* | "link to an active league from Basics (only league organizers, IC, or NC for same-country leagues)" |
*
* @param {Og_Cfg_League_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_league_desc = /** @type {((inputs?: Og_Cfg_League_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_League_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("lier à une ligue active depuis Général (organisateurs de ligue, IC ou NC pour les ligues du même pays uniquement)")
	if (locale === "es") return /** @type {LocalizedString} */ ("vincular a una liga activa desde **General** (solo organizadores de la liga, IC o NC para ligas del mismo país)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("vincula a uma liga ativa a partir de Geral (apenas organizadores da liga, IC, ou NC para ligas do mesmo país)")
	if (locale === "it") return /** @type {LocalizedString} */ ("collegamento a un campionato attivo dalla sezione **Generale** (solo organizzatori del campionato, IC o NC per campionati dello stesso paese)")
	return /** @type {LocalizedString} */ ("link to an active league from Basics (only league organizers, IC, or NC for same-country leagues)")
});